<template>
	<div>
		<div class="ft20 cl-main ftw600">角色管理</div>
		
		<div class="form-search-box mt20 ">
			<a-form layout="inline">
				<a-form-item label="角色名称">
					<a-input v-model="search.keywords" placeholder="请输入角色名称"></a-input>
				</a-form-item>
				
				<a-form-item>
					<a-button @click="searchAct" type="primary">查询</a-button>
					<a-button @click="cancelAct" class="ml10">取消</a-button>
				</a-form-item>
			</a-form>
		</div>
		
		<div class="mt20">
			<div class="pd20 bg-w " style="min-height: 800px;">
				<div class="">
					<a-button type="primary" icon="plus" @click="add()">添加角色</a-button>
				</div>
				
				<div class="mt20 ">
					<a-radio-group v-model="search.status" button-style="solid" @change="changeType">
						<a-radio-button :value="-1">
							全部
						</a-radio-button>
						<a-radio-button :value="1">
							正常
						</a-radio-button>
						<a-radio-button :value="0">
							停用
						</a-radio-button>
					</a-radio-group>
				</div>
				
				<div class="mt20">
					<div class="wxb-table-gray">
						<a-table rowKey="role_id" :columns="columns" :pagination="pagination" @change="handleTableChange"
							:data-source="datas" :loading="loading">
							<div class="flex center" slot="companyapp" slot-scope="record">
								{{record.company_app_name}}（{{record.app_name}}）
							</div>
							<template slot="action" slot-scope="record">
								<div class="flex center">
									<a class="bd-sky-blue fs12" href="javascript:;" @click="edit(record)">
										<span>编辑</span>
									</a>
									<a class="bd-red fs12" href="javascript:;" @click="del(record)">
										<span>删除</span>
									</a>
								</div>
							</template>
						</a-table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				loading: false,
				pagination: {
					current: 1,
					pageSize: 10, //每页中显示10条数据
					total: 0,
				},
				search: {
					keywords: '',
					status: -1,
				},
				columns: [
					{title: 'ID',dataIndex: 'role_id',align: 'center'},
					{title: '角色名称',dataIndex: 'role_name',align: 'center'},
					{title: '标识',dataIndex: 'role_key', align: 'center'},
					{title: '排序',dataIndex: 'sort',align: 'center'},
					{title: '状态',dataIndex: 'status.text',align: 'center'},
					{title: '所属应用',key: 'companyapp',align: 'center',scopedSlots: {customRender: 'companyapp'}},
					{title: '添加时间',dataIndex: 'create_time',align: 'center'},
					{title: '操作',key: 'action',align: 'center',scopedSlots: {customRender: 'action'}}
				],
				datas: [],
			}
		},
        created(){
            this.getLists();
        },
		methods:{
			getLists(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('platform/account/role/getAppRole',{
					limit:this.pagination.pageSize,
					page:this.pagination.current,
					keywords:this.search.keywords,
					status:this.search.status,
				}).then(res=>{
					this.pagination.total=res.total;
					this.datas=res.list;
					this.loading=false;
				}).catch(res=>{
					this.loading=false;
				})
			},
			
			del(record){
				this.$confirm({
					title:'确认删除当前角色吗？',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('platform/account/role/del',{
								role_id: record.role_id,
							}).then(res=>{
								this.$message.success('删除成功',1,()=>{
									this.getLists();
								});
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
			},
			
			changeType() {
				this.pagination.current = 1;
				this.getLists();
			},
			
			add(){
				this.$router.push('/setting/roles/edit')
			},
			edit(record){
				this.$router.push('/setting/roles/edit?id='+ record.role_id + '&app_id=' + record.app_id)
			},

			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current;
				this.getLists();
			},
            pageChange(e){
				this.pagination.current = parseInt(e);
				this.getLists();
			},
			searchAct(){
				this.pagination.current = 1;
				this.getLists();
			},
			cancelAct(){
				this.pagination.current = 1;
				this.searchCancel();
				this.getLists();
			},
			//列表选中时操作
			onSelectChange (selectedRowKeys) {
				this.selectedRowKeys = selectedRowKeys
			},
			searchCancel(){
				//改变搜索的表单的初始值
				for(let key  in this.pre_search){
					this.search[key]=this.pre_search[key];
				}
			},
			// getLists(){
			//     this.loading = true;

			//     setTimeout(()=>{
			//         this.loading = false;
			//     },2000);
			// }
		}
	}
</script>

<style>
</style>
